import React from 'react';
import BaseModel from '../../BaseModal'
import { FlexWrapperCenter, LineView, GapView } from '../../styles/WrapperStyles';
import styled, { css } from 'styled-components';

const ParentDiv = styled.div`    
  width: 445px;
  height:239px;  
  border-radius: 20px;  
`;

const TextView = styled.div`  
  height: 24px;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  ${props => props.cursor && css`
    cursor:pointer;
  `}
`;

const GenderModal = (props) => {
    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                <GapView height="20px" />
                <FlexWrapperCenter>
                    <TextView>Change gender to</TextView>
                </FlexWrapperCenter>
                <GapView height="50px" />
                <FlexWrapperCenter>
                    <TextView cursor onClick={() => props.updateGender("Male")}>Male</TextView>
                </FlexWrapperCenter>
                <GapView height="10px" />
                <FlexWrapperCenter>
                    <LineView width="400px" />
                </FlexWrapperCenter>
                <GapView height="10px" />
                <FlexWrapperCenter>
                    <TextView cursor onClick={() => props.updateGender("Female")}>Female</TextView>
                </FlexWrapperCenter>
            </ParentDiv>
        </BaseModel>
    );
};

export default GenderModal;